// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const etusivu = {
  tyyliLammin: asset("1577112842-lamminsquare.jpg", {
    alt: "Ester1 Lämmin",
    title: "Lämmin",
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1.112033,
  }),
  tyyliRaikas: asset("1577112851-raikassquare.jpg", {
    alt: "Raikas",
    title: "Raikas",
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1.112033,
  }),
  tyyliSisustusTumma: asset("1577112860-tummasquare.jpg", {
    alt: "Ester1 Tumma",
    title: "Tumma",
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1.112033,
  }),
  tyyliSisustusUniikki: asset("1616152177-uniikki-nelio2-min.jpg", {
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1.005435,
  }),
  argumentti1H: "Moderneimmat tilat",
  argumentti1B: "Suunnittelemme tilaratkaisun yhdessä yrityksenne kanssa niin, että se tukee liiketoimintaanne ja luo viihtyisän ilmapiirin. Tilamme vastaavat tämän päivän työkulttuurin vaatimuksiin, joissa korostuvat työn liikkuvuus, inspiroiva ympäristö ja luovat tilaratkaisut.",
  argumentti1Btn: "Tilaratkaisu",
  argumentti1Img: asset("1630591474-kaytava-nelio.jpg", {
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1,
  }),
  argumentti2H: "Nopeimmat yhteydet",
  argumentti2B: "Esterinportti 1:een on helppo tulla mistä päin pääkaupunkiseutua – tai oikeastaan – mistä päin Suomea tahansa. Kaikki junat pysähtyvät Pasilassa, kaikki Helsinkiin johtavat pääväylät ovat alle 10 minuutin päässä ja keskustaan kiitää junalla vain viidessä minuutissa. ",
  argumentti2Img: asset("1653899958-julkisivu-4.jpg", {
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1,
  }),
  argumentti2Btn: "Sijainti",
  heroTitle: "Pasilan tähtien alla on tilaa loistaa.",
  heroLead: "Ester1 tarjoaa täysin uudistetut ekologiset toimistotilat 10–150 hengen yrityksille. ",
  heroCtaText: "Laske hinta-arvio",
  heroCtaLink: "/tilaratkaisu/#tila-ja-hinta",
  heroImg: asset("1655981672-yleiset-tilat-10-web.jpg", {
    sizes: "(max-width: 1200px) 100vw, 1200px",
    aspectRatio: 1.777778,
  }),
  heroLayer: {
    alpha: 26,
    blue: 38,
    green: 24,
    red: 0,
  },
  miksiB: "Suunnittelemme yrityksenne toimintaan ja tulevaisuuden näkymiin sopivan tilaratkaisun, jossa neliöt laitetaan hyötykäyttöön ja arki luistaa. ",
  miksiH: "Miksi Ester1?",
  seoMetaTags: {
    tags: [
      {
        tagName: "title",
        content: "Ester1 tarjoaa täysin uudistetut toimitilat keskellä uutta Pasilaa ",
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:title",
          content: "Ester1 tarjoaa täysin uudistetut toimitilat keskellä uutta Pasilaa ",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:title",
          content: "Ester1 tarjoaa täysin uudistetut toimitilat keskellä uutta Pasilaa ",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "description",
          content: "Ester1 tarjoaa vuonna 2022 täysin uudistetut ekologiset toimistotilat 10–150 hengen yrityksille aivan Triplan vieressä osoitteessa Esterinportti 1.  Erinomaisen sijaintinsa ansiosta Esterinportti 1:een on nopea tulla töihin mistä suunnasta tahansa. Tutustu ja laske sopiva tilaratkaisu yrityksellenne.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:description",
          content: "Ester1 tarjoaa vuonna 2022 täysin uudistetut ekologiset toimistotilat 10–150 hengen yrityksille aivan Triplan vieressä osoitteessa Esterinportti 1.  Erinomaisen sijaintinsa ansiosta Esterinportti 1:een on nopea tulla töihin mistä suunnasta tahansa. Tutustu ja laske sopiva tilaratkaisu yrityksellenne.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:description",
          content: "Ester1 tarjoaa vuonna 2022 täysin uudistetut ekologiset toimistotilat 10–150 hengen yrityksille aivan Triplan vieressä osoitteessa Esterinportti 1.  Erinomaisen sijaintinsa ansiosta Esterinportti 1:een on nopea tulla töihin mistä suunnasta tahansa. Tutustu ja laske sopiva tilaratkaisu yrityksellenne.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:card",
          content: "summary_large_image",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:modified_time",
          content: "2022-05-30T08:42:47Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:published_time",
          content: "2019-11-09T10:09:02Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:locale",
          content: "fi_FI",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:type",
          content: "article",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:site_name",
          content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:image",
          content: "/content-images/1614434226-1-krsyhteisaula02-2021.jpg",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:image",
          content: "/content-images/1614434226-1-krsyhteisaula02-2021.jpg",
        },
      },
    ],
  },
  sijaintiB: "Erinomaisen sijaintinsa ansiosta Esterinportti 1:een on nopea tulla töihin mistä suunnasta tahansa.",
  sijaintiBtn: "Sijainti & Palvelut",
  sijaintiH: "Sijainti",
  sijaintiImg: asset("1577112833-esteri-karttakuva-1000x1000-v2.jpg", {
    alt: "ester1 osoite esterinportti 1",
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1,
  }),
  tilaratkaisuB: "Suunnittelemme yrityksenne toimintaan ja tulevaisuuden näkymiin sopivan tilaratkaisun, jossa neliöt laitetaan hyötykäyttöön ja arki luistaa.",
  tilaratkaisuBtn: "Tilaratkaisu",
  tilaratkaisuH: "Tilaratkaisu yrityksenne tarpeisiin",
  tilaratkaisuList1: "Arvioi tilatarpeesi, valitse sisustustyyli ja laske alustava hinta-arvio.",
  tilaratkaisuList2: "Otamme yhteyttä ensi tilassa ja kartoitamme tarpeenne.",
  tilaratkaisuList3: "Saatte tarjouksen kahden työpäivän kuluessa kartoituksesta.",
  tilaratkaisuList4: "Olette valmiita muuttamaan uusiin toimistotiloihin Pasilan sydämeen.",
  tyyliB: "Valitkaa sisustustyyli ammattilaisten suunnittelemista kolmesta tyylivaihtoehdosta tai tilatkaa oma tilasuunnittelu.",
  tyyliBtn: "Tyyli & Sisustus",
  tyyliH: "Yrityksenne näköiset tilat",
};

module.exports = { etusivu };
